import { createActions, createReducer } from 'reduxsauce'

import BaseLegalService from '../servicos/BaseLegalService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaBaseLegalInicio: [],
    buscaBaseLegalSucesso: ['baseLegal'],
    buscaBaseLegalErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaBaseLegal = () => {
    return dispatch => {
        dispatch(Creators.buscaBaseLegalInicio())
        let serv = new BaseLegalService()
        return serv
            .getBaseLegal()
            .then(response => dispatch(Creators.buscaBaseLegalSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaBaseLegalErro(error)))
    }
}

const buscaBaseLegalInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaBaseLegalErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaBaseLegalSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.baseLegal, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_BASE_LEGAL_INICIO]: buscaBaseLegalInicio,
    [Types.BUSCA_BASE_LEGAL_ERRO]: buscaBaseLegalErro,
    [Types.BUSCA_BASE_LEGAL_SUCESSO]: buscaBaseLegalSucesso,
})
